import _defineProperty from "/vercel/path0/web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["spacing", "children"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// ../../../react-shim.js
import React from "react";

// src/switch.tsx
import { useCheckbox } from "@chakra-ui/checkbox";
import { chakra, forwardRef, omitThemingProps, useMultiStyleConfig } from "@chakra-ui/system";

// ../../utilities/shared-utils/src/index.ts
var cx = function cx() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }
  return classNames.filter(Boolean).join(" ");
};
var dataAttr = function dataAttr(condition) {
  return condition ? "" : void 0;
};

// src/switch.tsx
import { useMemo } from "react";
var Switch = forwardRef(function Switch2(props, ref) {
  var styles = useMultiStyleConfig("Switch", props);
  var _omitThemingProps = omitThemingProps(props),
    _omitThemingProps$spa = _omitThemingProps.spacing,
    spacing = _omitThemingProps$spa === void 0 ? "0.5rem" : _omitThemingProps$spa,
    children = _omitThemingProps.children,
    ownProps = _objectWithoutProperties(_omitThemingProps, _excluded);
  var _useCheckbox = useCheckbox(ownProps),
    state = _useCheckbox.state,
    getInputProps = _useCheckbox.getInputProps,
    getCheckboxProps = _useCheckbox.getCheckboxProps,
    getRootProps = _useCheckbox.getRootProps,
    getLabelProps = _useCheckbox.getLabelProps;
  var containerStyles = useMemo(function () {
    return _objectSpread({
      display: "inline-block",
      position: "relative",
      verticalAlign: "middle",
      lineHeight: 0
    }, styles.container);
  }, [styles.container]);
  var trackStyles = useMemo(function () {
    return _objectSpread({
      display: "inline-flex",
      flexShrink: 0,
      justifyContent: "flex-start",
      boxSizing: "content-box",
      cursor: "pointer"
    }, styles.track);
  }, [styles.track]);
  var labelStyles = useMemo(function () {
    return _objectSpread({
      userSelect: "none",
      marginStart: spacing
    }, styles.label);
  }, [spacing, styles.label]);
  return /* @__PURE__ */React.createElement(chakra.label, _objectSpread(_objectSpread({}, getRootProps()), {}, {
    className: cx("chakra-switch", props.className),
    __css: containerStyles
  }), /* @__PURE__ */React.createElement("input", _objectSpread({
    className: "chakra-switch__input"
  }, getInputProps({}, ref))), /* @__PURE__ */React.createElement(chakra.span, _objectSpread(_objectSpread({}, getCheckboxProps()), {}, {
    className: "chakra-switch__track",
    __css: trackStyles
  }), /* @__PURE__ */React.createElement(chakra.span, {
    __css: styles.thumb,
    className: "chakra-switch__thumb",
    "data-checked": dataAttr(state.isChecked),
    "data-hover": dataAttr(state.isHovered)
  })), children && /* @__PURE__ */React.createElement(chakra.span, _objectSpread(_objectSpread({
    className: "chakra-switch__label"
  }, getLabelProps()), {}, {
    __css: labelStyles
  }), children));
});
Switch.displayName = "Switch";
export { Switch };